// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3tutL","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__33EyX"};